import { Injectable } from '@angular/core';
import { User } from '../../model/user/user';
import { AuthService } from '../../auth/auth-service.service';
import { Address } from '../../model/address/address';
import { Role } from '../../enums/role.enum';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public COLLECTION_NAME: string = 'users';

  constructor(
    authService: AuthService,
    private firestore: AngularFirestore
  ) { }

  createUser(_user: any, uid: string): User {
    var address: Address = new Address();
    address.state = _user.state;
    address.city = _user.city;
    address.description = _user.address;
    address.aditionalInfo = _user.addressInfo;

    var user = new User();
    user.firebaseId = uid;
    user.documentType = _user.documentType;
    user.document = _user.document;
    user.firstName = _user.firstName;
    user.lastName = _user.lastName;
    user.email = _user.email;
    user.phone = _user.phone;
    user.cellularPhone = _user.cellularPhone;
    user.addresses = [address];
    user.roles = [Role.CIUDADANO.toString()];
    user.dateCreated = new Date();
    user.accept_tyc = true;

    //console.log(user);
    //this.firestore.collection(this.COLLECTION_NAME).add(JSON.parse(JSON.stringify(user)));

    this.firestore.collection(this.COLLECTION_NAME).doc(uid).set(JSON.parse(JSON.stringify(user)))
      .then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });

    return user;

  }

  public getUserByUid(uid: string) {
    return this.firestore.collection(this.COLLECTION_NAME).ref.where('firebaseId', '==', uid).get();
  }

  public async userHasRole(uid: string, role: string): Promise<boolean> {
    //    return !(await this.findByCode(id)).empty;
    var exists: boolean;
    (await this.firestore.collection(this.COLLECTION_NAME).ref
      .where('firebaseId', '==', uid)
      .where('roles', 'array-contains', { role })
      .get().then((result) => {
        exists = result.size > 0;
      }).catch((error) => {
        exists = true;
      })
    );
    return exists;
  }
}
